export default function yupNickNameValidate(y) {
  y.addMethod(y.string, "nickName", function (name) {
    return this.test(
      "emojiMinMax",
      `${name}に入力不可能な文字が含まれています。`,
      function (value) {
        // 半角数字、半角英子文字、半角英大文字、全角数字、全角英小文字、全角英大文字、長音、ひらがな、カタカナ、半角カタカナ、漢字、サロゲートペア、サロゲートペア、漢字、サロゲートペア、々
        // 上記以外を含むか
        const regexp = /[^?!.*(0-9|a-z|A-Z|０-９|ａ-ｚ|Ａ-Ｚ|ー|\u3041-\u3096|\u30A1-\u30FA|\uFF61-\uFF9F|\u3400-\u9FFF|\uD840-\uD87F|\uDC00-\uDFFF|\uF900-\uFAFF|\u{20000}-\u{37FFF}|々).*]/u;
        // 含んでいた場合NGにしたいので、結果を反転して返す
        return !regexp.test(value);
      }
    );
  });
}
